module.exports = __webpack_public_path__ + "a7c9f5d99adba0516fb64c6c78ad87b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-1.jpg
// module id = 1149
// module chunks = 0